import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { AppConfigLoader } from '../../config/app-config.loader';
import { ToastService } from '../services/toast.service';

/**
 * Opt-out marker: callers that handle their own errors set this header to suppress the
 * automatic 400 toast. Stripped here so it never reaches the backend.
 */
export const SILENT_ERROR_HEADER = 'x-silent-error';

export const apiErrorToastInterceptor: HttpInterceptorFn = (request, next) => {
  const toast = inject(ToastService);
  const appConfigLoader = inject(AppConfigLoader);

  const isSilent = request.headers.get(SILENT_ERROR_HEADER) === 'true';
  const forwardedRequest = isSilent ? request.clone({ headers: request.headers.delete(SILENT_ERROR_HEADER) }) : request;

  return next(forwardedRequest).pipe(
    catchError((error: unknown) => {
      const error_ = error as any;
      const authOrigin = new URL(appConfigLoader.activeConfig().auth.issuer).origin;
      const isAuthEndpoint = request.url.startsWith(authOrigin);
      const isAlbumCreateEndpoint = request.url.includes('/albums');

      if (error_.status === 400 && !isAuthEndpoint && !isAlbumCreateEndpoint && !isSilent) {
        const description = error_.error.error_description ?? error_.error.message ?? error_.error.error;
        toast.showBadRequestToast(description as string);
      }
      return throwError(() => error_);
    })
  );
};
